import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'ipm-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {
  constructor(private renderer: Renderer2) {

  }

  ngOnInit(): void {
    setTimeout(() => {
      let loader = this.renderer.selectRootElement('#loader');
      this.renderer.setStyle(loader, 'display', 'none');
      
    });
  }


  goToIllpeopleMusic() {
    window.location.href = 'https://illpeoplemusic.com/';
  }

  
}
